// Common input styles for consistent styling across the application

export const baseInputStyles = "w-full px-4 text-base bg-white border rounded-lg transition-colors duration-200";

export const disabledInputStyles = "bg-slate-100";

export const inputFocusStyles = "focus:ring-0 focus:ring-offset-0 focus:outline-none focus-visible:ring-0 focus-visible:ring-offset-0";

export const searchInputStyles = `${baseInputStyles} h-14 text-slate-500 placeholder:text-slate-400 border-slate-200 hover:border-blue-500 focus:border-blue-500 ${inputFocusStyles}`;

export const standardInputStyles = `${baseInputStyles} h-10 text-slate-700 placeholder:text-slate-400 border-slate-300 hover:border-slate-400 focus:border-blue-500 ${inputFocusStyles}`;

export const standardTextAreaStyles = `${baseInputStyles} pt-2 min-h-20 text-slate-700 placeholder:text-slate-400 border-slate-300 hover:border-slate-400 focus:border-blue-500 resize-vertical ${inputFocusStyles}`;

export const smallInputStyles = `${baseInputStyles} h-8 text-sm text-slate-700 placeholder:text-slate-400 border-slate-300 hover:border-slate-400 focus:border-blue-500 ${inputFocusStyles}`; 